import apiService from 'src/enviroment';

const getColombia = async () => {
  try {
    const response = await apiService.get('/municipios/colombia/');
    if (response.status === 200) {
      return response.data.features;
    }
  } catch (error) {
    console.error('COLOMBIA', error);
  }
};

const getMunicipiosyZonas = async (unidad) => {
  try {
    const response = await apiService.get(
      `/admin/municipioszonas/?unidad_negocio_id=${unidad}`,
    );
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.error('COLOMBIA', error);
  }
};

const getBusinessPartner = async () => {
  try {
    const response = await apiService.get('/mapaconexion/socioscomerciales/');
    if (response.status === 200) {
      return response.data.socios_comerciales;
    }
  } catch (error) {
    console.error('COLOMBIA', error);
  }
};

const getCalculos = async (body, unidad) => {
  try {
    const response = await apiService.get(
      `/municipios/calculos/?meses=${body}&unidad_negocio_id=${unidad}`,
    );
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.error('getCalculos', error);
  }
};

const putBigQuery = async (body) => {
  try {
    const response = await apiService.put(
      '/segmentacion/maestros/territorios/',
      body,
    );
    if (response.status === 200 && response.data.success === 1) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('putBigQuery', error);
  }
};

const putZoneCountry = async (params) => {
  try {
    const response = await apiService.post('/admin/municipioszonas/', params);
    if (response.status === 200) {
      return true;
    }
  } catch (error) {
    return false;
  }
};

const deleteZoneCountry = async (params, unidad) => {
  try {
    const response = apiService.delete(
      `/admin/municipioszonas/?municipio_id=${params.id}&zona_id=${params.zona_id}&unidad_negocio_id=${unidad}`,
    );
    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const mapsService = {
  getColombia,
  getCalculos,
  putBigQuery,
  putZoneCountry,
  deleteZoneCountry,
  getBusinessPartner,
  getMunicipiosyZonas,
};

export default mapsService;
